import useStyles from './useStyles'
import { Checkbox } from '@mui/material'
import ModalMenuItemSuborganization from '../../Modals/ModalMenu/ModalMenu'

function TableItem ({ item, id, types, setLoading }) {
  const classes = useStyles()
  const getTypeName = (code) => {
    const result = types.filter(
      (element) => element.suborganizationTypeCode === code
    )
    if (result && result.length > 0) {
      return result[0].suborganizationTypeName
    } else {
      return null
    }
  }
  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemName}>{item.suborganizationName}</td>
        <td className={classes.itemNameLegal}>
          {item.suborganizationLegalName}
        </td>
        <td className={classes.itemCUIT}>{item.cuit}</td>
        <td className={classes.itemType}>
          {getTypeName(item.suborganizationTypeCode) || '- -'}
        </td>
        <td className={classes.itemKebab}>
          <ModalMenuItemSuborganization
            id={id}
            item={item}
            types={types}
            setLoading={setLoading}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
